// エディターでCSSのSyntax highlightを有効化する
const css = String.raw;

export const printStyles = css`
  /*! Source: https://github.com/h5bp/html5-boilerplate/blob/v6.1.0/src/css/main.css#L211-L278 */
  @media print {
    *,
    *:before,
    *:after {
      color: #000 !important;
      text-shadow: none !important;
      background: transparent !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    a,
    a:visited {
      text-decoration: underline;
    }

    a[href]:after {
      content: ' (' attr(href) ')';
    }

    thead {
      display: table-header-group;
    }

    tr,
    img {
      page-break-inside: avoid;
    }

    img {
      max-width: 100% !important;
    }

    p,
    h2,
    h3 {
      widows: 3;
      orphans: 3;
    }

    h2,
    h3 {
      page-break-after: avoid;
    }

    /* Custom styles by Findy */

    /* Tableに関するスタイルは上記のsourceには含まれていない。Findy転職で追加したスタイルである可能性が高い */
    .table {
      border-collapse: collapse !important;
    }
    .table td,
    .table th {
      background-color: #fff !important;
    }
  }
`;
